import { type WritableComputedRef } from "vue";

// VueUse router useRouteParam (with number transform)
// does not seem to handle numbers very well (0 especially)
// It will set a 0 value when the param is undefined wich happens when navigating
// to a route without the param.

// So this is a custom composable that handles numbers.
export const useRouteNumberParam = <T extends number | undefined>(
  name: string,
  defaultValue: T
): WritableComputedRef<T extends undefined ? number | undefined : number> => {
  const route = useRoute();
  const router = useRouter();

  const routeParam = computed({
    get() {
      const param = route.params[name] as string | undefined;
      if (param === undefined) return defaultValue;
      return Number(route.params[name] as string);
    },

    set(value?: number) {
      router.replace({
        params: { ...route.params, [name]: value },
        query: route.query,
      });
    },
  });

  // Set a default value if given
  if (defaultValue !== undefined && !routeParam.value) {
    routeParam.value = defaultValue as any;
  }

  return routeParam as any;
};
